import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/scrollText',
  title: window.language['menu.program.scrollText'],
  component: dynamicWrapper(app, [
    import('./model'),
    import('../../Material/Material/model'),
    import('../../HomePage/model'),
  ], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Program/ScrollText/index.js